import {
    AppContext,
    AppContextType,
    AutoHeightContainer,
    usePageSearch,
    useTherapproveModals,
    WebsiteLeadView
} from "@therapprove/common";
import { useContext } from "react";
import { WebsiteLeadHeader } from "./WebsiteLeadHeader";
import { useWebsiteLeadFilters } from "./useWebsiteLeadFilters";

export const WebsiteLeads = () => {
    // State
    const { organizationId } = useContext(AppContext) as AppContextType;
    const { embeddedCode } = useTherapproveModals();
    const { search, setSearch, debouncedSearch } = usePageSearch();
    const { filters, setFilters } = useWebsiteLeadFilters();

    // Handlers
    const handleOpenCodeModal = () => {
        if (!organizationId) return;
        embeddedCode.open({ organizationId });
    };

    return (
        <AutoHeightContainer style={{ gap: "1rem" }}>
            <WebsiteLeadHeader
                search={search}
                setSearch={setSearch}
                filters={filters}
                setFilters={setFilters}
                onOpenCodeModal={handleOpenCodeModal}
            />
            <WebsiteLeadView
                search={debouncedSearch}
                archived={filters.archived}
                therapyCategoryIds={filters.therapyCategoryIds}
            />
        </AutoHeightContainer>
    );
};
